import React                              from 'react';
		import { useEffect, useRef, useState    } from "react";
		import { ErrorBoundary                  } from "react-error-boundary";
		import {
			Routes,
			Route,
			Link,
			useNavigate,
		}                                         from "react-router-dom";

		import {
			motion,
			AnimatePresence
		} 						  				  from "framer-motion";	

		import {
			fallbackRender,
			add_sub,
			remove_subs
		}                                         from "../utils.jsx";
		import {COMP_REG}                         from "../comp_registry.js";
		import g_fn                               from '../g_fn';



		


		const AS    = g_fn.AS;
		

		// @req: keep reference to subs here and remove them on unmount or reload
		const SUB_ID = "bnode_pw9l9";
		const EN_BROKEN_COMP_LOGS = window.EN_BROKEN_COMP_LOGS || {};


		// local code - e.g sub components
		


		const comp_bnode_pw9l9 = (props)=>{
			const INFO  = {"model_id":"","model_name":"","op":"get_one","comp_id":"comp_bnode_pw9l9"};

			// Routes
			



			// FOR IS_MANY
			let idx = props.idx;   // also for protection from error when we might think is many but it's not
			let V = props.V || {}; // for protection from error


			// STATES
			const [rerender, set_rerender] = useState({});
const [M, set_M]     = useState(props.M || {})
const [PM, set_PM]     = useState(props.PM || [])
const [selected_M, set_selected_M]                         = useState(null)

			// REFS
			

			// EFFECTS
			
		useEffect(()=>{
			console.log("COMPONENT RERENDERED : ", JSON.stringify(M));
		},[rerender])
	

			useEffect(()=>{
				const deinit =  init();

				return () => {
					if(deinit && typeof(deinit) === "function") deinit();
				}
			}, []);
		

				useEffect(()=>{
					g_fn.bro_get_one(INFO, set_M, props);
				}, [props])
			

				useEffect(()=>{
					const sub = AS.GSTORE.subscribe((e)=>{
						// console.log("STORE CHANGED: ", INFO.model_name, INFO.op, " data: ",  e);

						// if model_id and eid are same
						// once data changes we will update M
					});

					return ()=>{
						sub.unsubscribe();
					}
				}, []);
			
useEffect(()=>{
			if(EN_BROKEN_COMP_LOGS.MODEL_EFFECT){
				const MI = INFO.model_name.toUpperCase() + " : " + INFO.op.toUpperCase();
				console.log("MODEL CHANGED : " + MI + "   => ", "model", M, " props", props);
			}
		}, [M])

		useEffect(()=>{

			if(!INFO.model_id) return;

			if(query) INFO.query = query; // fall back to query if there is no selected entity for the model id;
			const id = g_fn.get_selected_entity_id(props, INFO);
			if(!id) {
				return console.warn("NO ID FOUND TO UPDATE ENTITY");
			}

			(async () => {
				const r = await AS.GSTORE.get_one_entity(INFO.model_id, id);
				console.log("GSTORE GET ONE ENTITY : ", r);
				if(r) set_selected_M(r);
			})();

			const sub = AS.GSTORE.subscribe_selected_entities(INFO.model_id, (e) => {
				const id = g_fn.get_selected_entity_id(props, INFO);
				if(!id) return console.warn("NO ID FOUND TO UPDATE ENTITY IN SUBSCRIPTION");
				(async () => {
					const r = await AS.GSTORE.get_one_entity(INFO.model_id, id);
					console.log("GSTORE GET ONE ENTITY IN SUBSCRIPTION : ", r, INFO.model_id, INFO.comp_id);
					if(r) set_selected_M(r);
				})();
			});

			// On set in GSTORE set state
			const sub2 = AS.GSTORE.subscribe((e)=>{
				const {type, model_id, eid, data} = e;
				 if(!data || !data.id) return;
				 if(type !== 'set') return;
				 if(model_id !== INFO.model_id) return;
				 set_M(M=>{
				   if(eid !== M.id) return M;
				   return data;
				 })
			 });

			return () => {
				sub.unsubscribe();
				sub2.unsubscribe();
			}
		},[])
	

			// FUNCTIONS
			
			const init = ()=>{

				if(!INFO.model_id) return;


				INFO.query = query; // @todo : make it possible to change in UI editor
				const id = g_fn.get_one_find_id(props, INFO, relation);
				if(!id) {
					// errors => [{code:string, msg:string}]
					// warning => []
					console.warn("NO ID FOUND FOR GET_ONE : ", INFO);
					// return;
				}

				// subscription
				const sub = AS.GSTORE.subscribe_one(INFO.model_id, id, (e)=>{
					console.log("USER RE-RENDERED");
					const data = e.data;
					set_M(data);
				});


				// first time
				AS.GSTORE.get_one_entity(INFO.model_id, id, INFO.query);



				return ()=>{
					sub.unsubscribe();
				}

			}
		


			// STATEMENTS
			
		INFO.set_M          = set_M;
		INFO.on_created     = props.on_created  || props.INFO?.on_created;
		INFO.on_selected    = props.on_selected || props.INFO?.on_selected;
		const relation		= null;
		const query			=	null;
	



			// CONDITIONALS ATTRS
			const COND_ATTRS = {};
			
				COND_ATTRS["bnode_mt68b"] = COND_ATTRS["bnode_mt68b"] || {};
			

				COND_ATTRS["bnode_zfp4l"] = COND_ATTRS["bnode_zfp4l"] || {};
			

				COND_ATTRS["bnode_zrqvd"] = COND_ATTRS["bnode_zrqvd"] || {};
			

				COND_ATTRS["bnode_6u8dk"] = COND_ATTRS["bnode_6u8dk"] || {};
			

				COND_ATTRS["bnode_kym0y"] = COND_ATTRS["bnode_kym0y"] || {};
			

				COND_ATTRS["bnode_4g2qv"] = COND_ATTRS["bnode_4g2qv"] || {};
			

				COND_ATTRS["bnode_1qqnj"] = COND_ATTRS["bnode_1qqnj"] || {};
			

				COND_ATTRS["bnode_pw9l9"] = COND_ATTRS["bnode_pw9l9"] || {};
			


			// DYNAMIC REACT STATES
			const REACT_STATES = {};
REACT_STATES["M"] = {state: M, set_state: set_M};

		const AS_COMPONENTS = AS.components["comp_bnode_pw9l9"] || {};
		AS_COMPONENTS.REACT_STATES = REACT_STATES;
		AS.components["comp_bnode_pw9l9"] = AS_COMPONENTS;
	



			// MAPPED DATA
			const MAPPED_DATA = {};



			return (
				<ErrorBoundary fallbackRender={fallbackRender} onReset={(d) => {console.error(d)}}>
					
            <motion.div data_id="bnode_pw9l9" className="min-h-[64px] w-full h-fit overflow-auto flex gap-4 px-8 items-center justify-center" name="page:profile_update" findex="aA" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} id={"bnode_pw9l9" + (idx?"__"+idx:"")} onClick={(e)=>{
            g_fn.dev.emit_m(e, M, INFO)
        }} extra-attr >
                
            <div data_id="bnode_1qqnj" className="new-div w-full flex items-center justify-center flex-col gap-4 bg-[#eeeeee]" id={"bnode_1qqnj" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_6u8dk" className="new-div w-2/3 flex justify-start items-center" id={"bnode_6u8dk" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_zrqvd" className="new-div w-fit flex justify-start items-center gap-2  cursor-pointer text-[#FF5994] border border-[#FF5994] rounded-lg px-2 py-1" id={"bnode_zrqvd" + (idx?"__"+idx:"")} page_id="bnode_n381t" action="['go-to-page']" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_go_to_page(e, M, INFO, props)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_mt68b" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="arrow-left" className="w-6 h-6" id={"bnode_mt68b" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="m12 19-7-7 7-7" extra-attr >
                
            </path>
        

            <path data_id="" d="M19 12H5" extra-attr >
                
            </path>
        
            </svg>
        

            <div data_id="bnode_zfp4l" className="new-div w-fit flex items-center justify-center" id={"bnode_zfp4l" + (idx?"__"+idx:"")} extra-attr >
                Back
            </div>
        
            </div>
        
            </div>
        

            <div data_id="bnode_kym0y" className="new-div w-full flex items-center justify-center text-[28px] font-['Open_Sans'] text-2xl font-semibold" id={"bnode_kym0y" + (idx?"__"+idx:"")} extra-attr >
                Edit Profile
            </div>
        

            <div data_id="bnode_4g2qv" className="new-div w-full flex items-center justify-center" id={"bnode_4g2qv" + (idx?"__"+idx:"")} extra-attr >
                < COMP_REG.comp_bnode_bhyih {...{PM:[...PM, M], on_created: props.on_created || INFO.on_created, on_selected: props.on_selected || INFO.on_selected, INFO:INFO  }} extra-attr />
            </div>
        
            </div>
        
            </motion.div>
        
				</ErrorBoundary>
			)
		}

		export default comp_bnode_pw9l9;